import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CMSAuthService } from '../essentials/cms/auth/cms-auth.service';
import {
  CMSContentService,
  AuthToken
} from '../essentials/cms/content/cms-content.service';

import { ModalService } from '@fcp/lib-ui';
import { PagesService } from './pages.service';
import { switchMap, take } from 'rxjs/operators';

@Component({
  selector: 'fcp-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
  public page: any = [];
  public pageSlug: string;
  public idPage: string;
  public subPage: string;
  public loaded = false;
  public otherInsurance: any = {};
  public heightHeader = 77;
  public ready = false;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private cms: CMSContentService,
    private pagesService: PagesService,
    private cmsAuthService: CMSAuthService,
    private modalService: ModalService
  ) {
    const investmentReport = {
      title: '',
      subTitle: '',
    };

  }

  ngOnInit() {
    this.route.url.subscribe(params => {
      window?.scrollTo(0, 0);
      this.otherInsurance.insurances = [];
      const url = location.pathname.split('/');

      if (url[1] === 'paginas') {
        if (url.length === 4) {
          this.pageSlug = url[2] + '/' + url[3];
          if (url[2] === 'seguros') {
            this.pagesService
              .getConfigOtherInsurance()
              .pipe(
                switchMap(res => {
                  this.otherInsurance.title = res.title;
                  this.otherInsurance.subtitle = res.subtitle;
                  return this.cms.getInsurance(url[3]);
                }),
                take(1)
              )
              .subscribe(response => {
                this.otherInsurance.insurances = response;
              });
          }
        } else {
          this.pageSlug = url[2];
        }
      } else {
        if (url.length === 5) {
          this.pageSlug = url[3] + '/' + url[4];
          if (url[3] === 'seguros') {
            this.pagesService
              .getConfigOtherInsurance()
              .pipe(
                switchMap(res => {
                  this.otherInsurance.title = res.title;
                  this.otherInsurance.subtitle = res.subtitle;
                  return this.cms.getInsurance(url[4]);
                }),
                take(1)
              )
              .subscribe(response => {
                this.otherInsurance.insurances = response;
              });
          }
        } else {
          this.pageSlug = url[3];
        }
      }
      this.generateIdPage(this.pageSlug);
      this.load();
    });
  }

  load() {
    let token = this.cmsAuthService.getToken();
    if (!token) {
      this.cmsAuthService.auth().subscribe((newToken: AuthToken) => {
        token = newToken.token_type + ' ' + newToken.access_token;
        this.cmsAuthService.setToken(token);
        this.getContent();
      });
    } else {
      this.getContent();
    }
  }

  private generateIdPage(pageSlug) {
    const slugs = pageSlug.split('/');
    this.idPage = `app-pages-${slugs[0]}`;
    this.subPage = slugs[1] || '';
  }

  getContent() {
    this.pagesService.getPage(this.pageSlug).subscribe(page => {
      this.page = page.map(item => {
        const section = item.__typename.toLowerCase();
        this[section] ? this[section]++ : (this[section] = 1);
        item.classSection = `${section} _${this[section]}`;
        this.loaded = true;
        return item;
      });
    });
  }

  public clicked(obj) {
    if (obj.document || obj.externalLink) {
      const url = obj.document || obj.externalLink;
      return window.open(url);
    }

    if (obj) {
      let modalID = '';
      if (Array.isArray(obj)) {
        modalID = obj[0].id;
      } else {
        if (obj.modal.length > 0) {
          modalID = obj.modal[0].id;
        } else {
          return false;
        }
      }

      this.cms.openModal(modalID);
    }
  }

  public clickedPage(page) {
    if (page) {
      this.router.navigate([page]);
    }
  }

  public openAnchorModal(event) {
    if (event && event.button && event.button.modal) {
      this.cms.openModal(event.button.modal);
    }
    if (event && event.modal) {
      this.cms.openModal(event.modal, true);
    }
  }

  public openBannerModal(modal) {
    if (modal.isCredential) {
      this.modalService.open({
        tabs: null,
        buttons: null,
        data: null,
        img: '',
        title: '',
        titleTabs: null,
        subtitleTabs: null,
        type: 'Rede Credenciada',
        text: null
      });
    } else if (modal) {
      this.cms.openModal(modal);
    }
  }

  public checkLinkClicked($element) {
    if ($element) {
      this.cms.openModal($element);
    }
  }

  public scrollToElement($element): void {
    const secao = this.page.filter(item => {
      return item.id === $element;
    })[0];

    const element = document.getElementsByClassName(secao.classSection)[0];

    const elementPositionTop = element['offsetTop'] - this.heightHeader;
    window.scrollTo(0, elementPositionTop);
  }
}
